export { FalhaHttp } from './falha-http'
export {
  ESTRATEGIA_RETRY_PADRAO,
  type ClienteHttp,
  type ContextoRetry,
  type DestinoRetry,
  type EstrategiaRetry,
  type HeadersHttp,
  type MetodoHttp,
  type OpcoesHttp,
  type ParametrosHttp,
  type RespostaHttp,
  type TentativaRetry,
} from './http.tipos'
export {
  criarClienteHttpCondominio,
  type CredenciaisCondominio,
  type DependenciasClienteHttpCondominio,
} from './clientes/condominio.http'
